export default __webpack_public_path__ + "static/media/vuesax-linear-lock.a733c348.svg";